import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createWorkspaceUser,
  getWorkspaceUsers,
} from '../../../shared/api/magellan/workspaces';
import type { CreateWorkspaceUserDTO } from '../../../shared/api/magellan/workspaces/dto';
import { useActiveUserQuery } from '../../../shared/hooks/useActiveUserQuery.hook';

export function useCreateWorkspaceUser() {
  const queryClient = useQueryClient();
  const {
    data: { user: activeUser },
  } = useActiveUserQuery();

  const acticeWorkspaceId = activeUser.activeWorkspace?.id;

  return useMutation({
    mutationFn: (payload: CreateWorkspaceUserDTO) => {
      if (!acticeWorkspaceId) {
        throw new Error('No active workspace');
      }

      return createWorkspaceUser({ workspaceId: acticeWorkspaceId, payload });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getWorkspaceUsers.name, acticeWorkspaceId],
      });
    },
  });
}
